import { computed } from '@vue/composition-api'

export default {
  name: 'Progress',
  props: {
    value: {
      type: [Number, String],
      default: 0,
    },
    max: {
      type: Number,
      default: 1,
    },
    dark: {
      type: Boolean,
      default: false,
    },
    large: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    return {
      width: computed(() => ((props.value / props.max) <= 1 ? (props.value / props.max) : 1)),
      warning: computed(() => (props.value > props.max)),
    }
  },
}
